import React from "react"
import Divider from "@mui/material/Divider"
import IconButton from "@mui/material/IconButton"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import Drawer from "@mui/material/Drawer"
import { styled } from "@mui/material/styles"
import { Box, Tab, Tabs } from "@mui/material"
import Allocate from "./Controls/Allocate"
import Visaulise from "./Controls/Visaulise"
import Stats from "./Controls/Stats"
import Cups from "./Controls/Cups"
import Export from "./Controls/Export"
import ChangeRequests from "./Controls/ChangeRequests"
import Session from "./Controls/Session"

const drawerWidth = 400

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}))

function TabPanel({ children, value, index, keepMounted = false, ...other }) {
  const hidden = value !== index

  if (!keepMounted && hidden) return null

  return (
    <div
      role="tabpanel"
      hidden={hidden}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      <Box sx={{ p: 2, width: 240 }}>{children}</Box>
    </div>
  )
}

function a11yProps(index, disabled) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
    disabled: disabled,
  }
}

export default function SideControl({
  open,
  map_data,
  dispatch_ui,
  set_visualisation_settings,
  visualisation_settings,
  map_ref,
  change_requests,
  set_change_requests,
  dispatch_map_data,
}) {
  const [current_tab, set_current_tab] = React.useState(0)

  const handleChange = (event, newValue) => {
    set_current_tab(newValue)
  }

  const { au_geo_json } = map_data

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <IconButton
          onClick={() => {
            dispatch_ui({ type: "CLOSE_DRAWER" })
          }}
          style={{ position: "absolute", right: "10px" }}
        >
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>
      <Divider />
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          height: 224,
        }}
      >
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={current_tab}
          onChange={handleChange}
          sx={{ borderRight: 1, borderColor: "divider" }}
        >
          <Tab label="Allocate" {...a11yProps(0, au_geo_json === null)} />
          <Tab label="Visualise" {...a11yProps(1, au_geo_json === null)} />
          <Tab label="CUPs" {...a11yProps(2, au_geo_json === null)} />
          <Tab label="Stats" {...a11yProps(3, au_geo_json === null)} />
          <Tab label="Export" {...a11yProps(4, au_geo_json === null)} />
          <Tab
            label={`Changes ${change_requests.length ? ` (${change_requests.length})` : ""}`}
            {...a11yProps(5, au_geo_json === null)}
          />
          <Tab label="Session" {...a11yProps(6, au_geo_json === null)} />
        </Tabs>

        <TabPanel value={current_tab} index={0} keepMounted>
          <Allocate
            map_data={map_data}
            dispatch_map_data={dispatch_map_data}
            dispatch_ui={dispatch_ui}
          />
        </TabPanel>
        <TabPanel value={current_tab} index={1}>
          <Visaulise
            visualisation_settings={visualisation_settings}
            map_data={map_data}
            set_visualisation_settings={set_visualisation_settings}
            map_ref={map_ref}
          />
        </TabPanel>
        <TabPanel value={current_tab} index={2} keepMounted>
          <Cups
            map_data={map_data}
            dispatch_map_data={dispatch_map_data}
            dispatch_ui={dispatch_ui}
          />
        </TabPanel>
        <TabPanel value={current_tab} index={3}>
          <Stats au_geo_json={map_data.au_geo_json} />
        </TabPanel>
        <TabPanel value={current_tab} index={4}>
          <Export map_data={map_data} />
        </TabPanel>
        <TabPanel value={current_tab} index={5}>
          <ChangeRequests
            dispatch_map_data={dispatch_map_data}
            change_requests={change_requests}
            set_change_requests={set_change_requests}
          />
        </TabPanel>
        <TabPanel value={current_tab} index={6}>
          <Session />
        </TabPanel>
      </Box>
    </Drawer>
  )
}
